import { makeStyles } from "@mui/styles";

/**
 * Estilos para el componente Navbar
 * Incluye estilos para desktop y mobile, configuraciones de ajustes,
 * indicadores de garantía y elementos de navegación
 */
const useNavbarStyles = makeStyles((theme) => ({
  announcementsContainer: {
    padding: '1rem',
  },
  rootNavbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.main,
  },
  drawerContent: {
    width: 300,
  },

  // Estilos de texto y tipografía
  announcementText: {
    flex: 1,
    color: theme.palette.primary.main,
    fontSize: 18,
    marginTop: theme.spacing(1),
  },
  navBarTitle: {
    flex: 1,
    color: theme.palette.primary.lightBackground,
    fontSize: 20,
    marginLeft: theme.spacing(4),
  },
  navBarText: {
    fontSize: 20,
    color: theme.palette.primary.lightBackground,

  },
  navBarTextHighligt: {
    // Estilos para texto resaltado
  },

  // Estilos de cajas y contenedores de navegación
  navBarTextBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  navBarTextBoxSelected: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: '100%',
    backgroundColor: theme.palette.primary.main,
  },

  // Estilos de divisores
  divider: {
    [theme.breakpoints.down('md')]: {
      width: '75%',
    },
    [theme.breakpoints.up('md')]: {
      height: '25%',
    },
  },
  verticalDivider: {
    height: '40%',
    width: 2,
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(2),
  },

  // Estilos de iconos
  navBarIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.lightBackground,
  },

  // Estilos de garantía con diferentes estados
  guaranteeLabel: {
    fontFamily: 'ITC Officina Sans Std, Book',
  },
  guaranteeValue: {
    fontFamily: 'ITC Officina Sans Std, Bold',
    color: theme.palette.green.main,
  },
  guaranteeValueWarning: {
    fontFamily: 'ITC Officina Sans Std, Bold',
    color: theme.palette.yellow.secondary,
  },
  guaranteeValueDanger: {
    fontFamily: 'ITC Officina Sans Std, Bold',
    color: theme.palette.red.secondary,
  },

  // Estilos de contenedores de configuraciones
  settingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: `3px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(2),
    width: 580,
  },
  settingsContainerRH: {
    display: 'flex',
    flexDirection: 'row',
    border: `3px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(2),
    width: 580,
  },
  settingsTitle: {
    fontFamily: 'ITC Officina Sans Std, Bold',
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginTop: "5px",
  },
  settingSection: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },

  // Estilos de botones
  settingsButton: {
    border: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontFamily: 'ITC Officina Sans Std, Bold',
    fontWeight: 'bold',
    fontSize: 16,
    width: 180,
  },
  rhSettingsButton: {
    border: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontFamily: 'ITC Officina Sans Std, Bold',
    fontWeight: 'bold',
    fontSize: 16,
    width: 180,
  },
  previewModeButton: {
    border: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontFamily: 'ITC Officina Sans Std, Bold',
    fontWeight: 'bold',
    fontSize: 16,
    width: 100,
  },

  // Estilos de popovers
  awardPopover: {
    backgroundColor: 'transparent',
  },
  awardsPaper: {
    backgroundColor: 'transparent',
  },
}))

export default useNavbarStyles